// Shared trademark data constants for country and Nice class selectors
import { countryOptions } from "../variables/countryOptions";

// Popular countries based on actual DB usage
export const POPULAR_COUNTRY_CODES = ["US", "GB", "EM", "WO", "DE", "FR", "ES", "IT", "CA", "SE", "DK", "FI"];

// Build countries from countryOptions - only individual countries (string values)
export const ALL_COUNTRIES = (() => {
  const countries = countryOptions
    .filter(opt => typeof opt.value === "string")
    .map(opt => {
      const flag = opt.label.split(":")[0].trim();
      const name = opt.label.split(":")[1]?.trim() || opt.value;
      return {
        code: opt.value,
        name: name,
        flag: flag,
        popular: POPULAR_COUNTRY_CODES.includes(opt.value),
      };
    });

  // Add special entries for WIPO and EU
  const specialEntries = [
    { code: "WO", name: "WIPO (Worldwide)", flag: "🌐", popular: true },
    { code: "EM", name: "European Union", flag: "🇪🇺", popular: true },
  ];

  specialEntries.forEach(entry => {
    if (!countries.find(c => c.code === entry.code)) {
      countries.unshift(entry);
    }
  });

  return countries;
})();

// Popular Nice classes based on actual DB usage
export const POPULAR_CLASS_CODES = [42, 35, 9, 36, 41, 32, 44];

// All 45 Nice classes with short descriptions
export const ALL_NICE_CLASSES = [
  { code: 1, name: "Chemicals" },
  { code: 2, name: "Paints & Varnishes" },
  { code: 3, name: "Cosmetics & Cleaning" },
  { code: 4, name: "Lubricants & Fuels" },
  { code: 5, name: "Pharmaceuticals" },
  { code: 6, name: "Metal Goods" },
  { code: 7, name: "Machines & Tools" },
  { code: 8, name: "Hand Tools" },
  { code: 9, name: "Software & Electronics" },
  { code: 10, name: "Medical Devices" },
  { code: 11, name: "Lighting & Heating" },
  { code: 12, name: "Vehicles" },
  { code: 13, name: "Firearms & Explosives" },
  { code: 14, name: "Jewelry & Watches" },
  { code: 15, name: "Musical Instruments" },
  { code: 16, name: "Paper & Printed Matter" },
  { code: 17, name: "Rubber & Plastics" },
  { code: 18, name: "Leather Goods" },
  { code: 19, name: "Building Materials" },
  { code: 20, name: "Furniture" },
  { code: 21, name: "Household Utensils" },
  { code: 22, name: "Ropes & Textile Materials" },
  { code: 23, name: "Yarns & Threads" },
  { code: 24, name: "Textiles & Linens" },
  { code: 25, name: "Clothing & Footwear" },
  { code: 26, name: "Lace & Embroidery" },
  { code: 27, name: "Carpets & Rugs" },
  { code: 28, name: "Games & Toys" },
  { code: 29, name: "Meat & Dairy Products" },
  { code: 30, name: "Coffee, Tea & Food" },
  { code: 31, name: "Agricultural Products" },
  { code: 32, name: "Beverages (Non-Alcoholic)" },
  { code: 33, name: "Alcoholic Beverages" },
  { code: 34, name: "Tobacco" },
  { code: 35, name: "Advertising & Business" },
  { code: 36, name: "Financial Services" },
  { code: 37, name: "Construction & Repair" },
  { code: 38, name: "Telecommunications" },
  { code: 39, name: "Transport & Travel" },
  { code: 40, name: "Material Treatment" },
  { code: 41, name: "Education & Entertainment" },
  { code: 42, name: "Scientific & Tech Services" },
  { code: 43, name: "Food & Drink Services" },
  { code: 44, name: "Medical & Beauty Services" },
  { code: 45, name: "Legal & Security Services" },
].map(c => ({ ...c, popular: POPULAR_CLASS_CODES.includes(c.code) }));

export const POPULAR_COUNTRIES = ALL_COUNTRIES.filter(c => c.popular);
export const POPULAR_CLASSES = ALL_NICE_CLASSES.filter(c => c.popular);

// Grade color helper
export const getGradeColor = grade => {
  switch (grade) {
    case "A": return { bg: "rgba(34, 197, 94, 0.15)", text: "#22c55e", border: "rgba(34, 197, 94, 0.3)" };
    case "B": return { bg: "rgba(59, 130, 246, 0.15)", text: "#3b82f6", border: "rgba(59, 130, 246, 0.3)" };
    case "C": return { bg: "rgba(245, 158, 11, 0.15)", text: "#f59e0b", border: "rgba(245, 158, 11, 0.3)" };
    case "D": return { bg: "rgba(239, 68, 68, 0.15)", text: "#ef4444", border: "rgba(239, 68, 68, 0.3)" };
    case "F": return { bg: "#ef4444", text: "#fff", border: "#ef4444" };
    default: return { bg: "rgba(0,0,0,0.05)", text: "#666", border: "rgba(0,0,0,0.1)" };
  }
};
